module.exports = __webpack_public_path__ + "static/media/7.e4a8ab90.JPG";